
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28 4.469v19.188l-.594.25-7.375 3.156-.375-.125-7.625-2.875-6.625 2.844L4 27.532V8.344l.594-.25 7.375-3.156.375.125 7.625 2.875 6.625-2.844zM13 7.438v14.875l6 2.25V9.688zM11 7.5L6 9.656V24.5l5-2.156V7.5zm15 0l-5 2.156V24.5l5-2.156V7.5z"}})])
          )
        }
      }
    